import { render } from "./Text.vue?vue&type=template&id=4dfd4881&scoped=true"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import "./Text.vue?vue&type=style&index=0&id=4dfd4881&scoped=true&lang=scss"

import exportComponent from "/Users/pepijnvdk/TNT/wewantyou/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfd4881"]])

export default __exports__